var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"smartpost"},[_c('SmartPOSTBannersView',{attrs:{"id":"smartpost","timestamp":_vm.timestamp}}),_c('SectionWhatSmartPOST'),_c('SectionWhySmartPOST'),_c('SectionSmartPOSTLearnMore'),_c('SectionForUserSmartPOST'),_c('SectionHelpCenter',{attrs:{"hrefLinkFAQ":'https://help.xid.inc/smartpost'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }